import {hrmsWithPath} from "../../services/http/api/rest";

const rest = hrmsWithPath('/v1/chat')
const restAPI = hrmsWithPath('v1')

const chat = {
    create: (data: any) => rest.post('', {}, data, {}),
    getAllChatByUserId: (userId: string) => rest.get('/user/{{userId}}', {userId}, {}),
    delete: (threadId: string) => rest.del('{{threadId}}', {threadId}, {}, {},),
    getAllMessageByChatId: (threadId: string) => restAPI.get('message/chat/{{threadId}}', {threadId}, {}),
}

export default chat;